// A3 — Admin-only tour: Resources. 3 steps on /resources.
export default {
  key: 'A3',
  route: '/resources',
  steps: [
    {
      id: 'workcenters',
      target: '[data-tour-id="resources.workcenters-tab"]',
      title: 'Workcenters',
      desc: "Workcenters are the actual machines grouped in Workcenter Groups. Each workcenter defined one or many manufacturing actions.",
    },
    {
      id: 'workers',
      target: '[data-tour-id="resources.workers-tab"]',
      title: 'Workers',
      desc: "Workers execute production tasks on the shop floor. They identify themselves by barcode — they don't log in with personal accounts. Add workers here; assign them to workcenters from the Workcenters screen.",
    },
    {
      id: 'sites',
      target: '[data-tour-id="resources.sites-tab"]',
      title: 'Sites',
      desc: "Sites are physical locations of your manufacturing. Users' role can be scoped to one, some, or all sites.",
    },
  ],
}
